import { Column } from "@/components/Column";

const BUBBLES = [
  { left: 22, delayS: 0, sizePx: 6 },
  { left: 41, delayS: -0.7, sizePx: 4 },
  { left: 58, delayS: -1.3, sizePx: 7 },
  { left: 73, delayS: -0.3, sizePx: 5 },
  { left: 34, delayS: -1.8, sizePx: 5 },
];

// After dark the pond turns into a bubbling cauldron: a green wash on the
// water, rising bubbles, and a glow above the night tint. Same box as
// PlayyardPond.
export const PlayyardCauldronPond = ({ isBrewing }: { isBrewing: boolean }) => {
  return (
    <>
      <Column
        className="pointer-events-none absolute left-[4%] top-[59%] z-[7] h-[12%] w-[27%] overflow-hidden rounded-[50%] bg-[radial-gradient(ellipse,rgb(120_255_120_/_0.55),rgb(40_160_70_/_0.45)_60%,rgb(20_80_40_/_0.35))] transition-opacity [transition-duration:1500ms]"
        style={{ opacity: isBrewing ? 1 : 0 }}
      >
        {isBrewing
          ? BUBBLES.map((bubble) => (
              <Column
                key={bubble.left}
                className="staffer-pet-yard-bubble absolute top-[55%] rounded-full border border-[#c8ffb0]/80"
                style={{
                  left: `${bubble.left.toString()}%`,
                  width: bubble.sizePx,
                  height: bubble.sizePx,
                  animationDelay: `${bubble.delayS.toString()}s`,
                }}
              />
            ))
          : null}
      </Column>
      <Column
        className="pointer-events-none absolute left-[0%] top-[50%] z-[39] h-[30%] w-[35%] rounded-[50%] bg-[radial-gradient(ellipse,rgb(110_255_120_/_0.35),transparent_65%)] mix-blend-screen transition-opacity [transition-duration:1500ms]"
        style={{ opacity: isBrewing ? 1 : 0 }}
      />
    </>
  );
};
